// extracted by mini-css-extract-plugin
export var callCard = "_im-0";
export var callMessageButton = "_im-1";
export var helpIcon = "_im-3";
export var helpIconContainer = "_im-4";
export var verticalDivider = "_im-2";